import { AUTOSHIP_CONST } from '../constants';

/*
 * If the user is logged in, we need to add a one-time option to the frequency drop down
 */
export const getFrequencyOptions = (userHasSubscriptions = false) => {
    if (!userHasSubscriptions) {
        return AUTOSHIP_CONST.OPTIONS;
    }

    return [
        {
            label: AUTOSHIP_CONST.ONE_TIME_LABEL,
            value: AUTOSHIP_CONST.ONE_TIME_VALUE,
        },
        ...AUTOSHIP_CONST.OPTIONS,
    ];
};
